import { Col, Container, Row } from '@bootstrap-styled/v4';
import React from 'react';
import styled from 'styled-components';
import IntroductionTitle from './introduction-title';
import colors from 'shared-components/theme/colors';
import IntroductionDesc from './introduction-desc';
import { baseURL } from 'shared-components/theme/helpers';
import CountUp from 'react-countup';
import ScrollAnimation from 'react-animate-on-scroll';
import Media from 'shared-components/theme/medias';
const Results = () => {
    const resultsInfo = [
        {
            count: 22,
            suffixIco: '+',
            suffixTxt: 'Years',
            text: 'in-market',
            icon: `${baseURL}assets/images/geos/pakistan/result_ico-1.svg`,
        },
        {
            count: 8500,
            suffixIco: '+',
            text: 'Agents deployed',
            icon: `${baseURL}assets/images/geos/pakistan/result_ico-2.svg`,
        },
        {
            count: 60,
            suffixIco: '%',
            text: 'C1 fluency',
            icon: `${baseURL}assets/images/geos/pakistan/result_ico-3.svg`,
        },
        {
            count: 10,
            text: 'Delivery sites',
            icon: `${baseURL}assets/images/geos/pakistan/result_ico-4.svg`,
        },
        {
            count: 78,
            text: 'eNPS',
            icon: `${baseURL}assets/images/geos/pakistan/result_ico-5.svg`,
        },
    ];
    return (
        <Wrap id="results">
            <Container style={{ position: 'relative' }}>
                <Row style={{ alignItems: 'center' }}>
                    <Col lg="7">
                        <TextWrap>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOnce={true}>
                                <IntroductionTitle
                                    title={
                                        'Built For Results: <br/> Our Pakistan Advantage'
                                    }
                                    textColor={colors.geoWhite[100]}
                                />
                            </ScrollAnimation>

                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOnce={true}
                                delay={100}>
                                <IntroductionDesc
                                    desc={
                                        'Backed by decades of experience and deep regional expertise in Pakistan, ibex delivers scale, quality, and performance for the world’s largest brands.'
                                    }
                                    textColor={colors.geoWhite[100]}
                                />
                            </ScrollAnimation>
                        </TextWrap>
                    </Col>
                    <Col lg="5">
                        <Row className="results_row">
                            {resultsInfo.map((info, i) => (
                                <Col
                                    key={i}
                                    lg={i == 0 ? '12' : '6'}
                                    className="cols">
                                    <InfoBox>
                                        <img
                                            src={info.icon}
                                            alt="ibex"
                                            width={32}
                                            height={32}
                                            className="info_ico"
                                            loading="lazy"
                                        />
                                        <h3 className="info_count">
                                            <CountUp
                                                start={0}
                                                end={info.count}
                                                enableScrollSpy={true}
                                                scrollSpyOnce={true}
                                            />
                                            <span className="count_suffix">
                                                {info.suffixIco
                                                    ? info.suffixIco
                                                    : ''}
                                            </span>
                                            {info.suffixTxt && info.suffixTxt}
                                        </h3>
                                        <p className="info_text">{info.text}</p>
                                    </InfoBox>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>
            </Container>
        </Wrap>
    );
};

export default Results;
const Wrap = styled.section`
    background: #0b2014;
    position: relative;
    z-index: 2;
    scroll-margin-top: 100px;
    &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 90%;
        background: url(${baseURL}assets/images/geos/pakistan/bg-globe.svg)
            no-repeat center/contain;
        z-index: 1;
    }

    .results_row {
        gap: 15px 0;
        .cols {
            padding-left: 0;

            ${Media('tablet')} {
                padding-left: 20px;
                margin: 0;
                gap: 0;
            }
        }
    }
`;
const TextWrap = styled.div`
    padding-right: 200px;
    position: relative;
    z-index: 2;
    ${Media('laptops')} {
        padding-right: 100px;
    }
    ${Media('mobile')} {
        padding-right: 20px;
    }
`;
const InfoBox = styled.div`
    backdrop-filter: blur(3px) brightness(1.2);
    padding: 20px;
    border-radius: 10px;
    position: relative;
    transition: 0.3s ease;
    border: 1px solid transparent;
    z-index: 3;
    &:hover {
        border: 1px solid ${colors.geoGreen[90]};
    }
    .info_ico {
        position: absolute;
        top: 15px;
        right: 15px;

        ${Media('laptops')} {
            top: 8px;
            right: 8px;
            width: 22px;
            height: 22px;
        }
        ${Media('mobile')} {
            width: 32px;
            height: 32px;
        }
    }
    .info_count {
        color: ${colors.geoWhite[100]};
        margin: 0;
        .count_suffix {
            color: ${colors.geoGreen[50]};
        }

        @media (max-width: 1680px) {
            font-size: 38px;
        }
        ${Media('laptops')} {
            font-size: 30px;
        }
    }

    .info_text {
        color: ${colors.geoWhite[100]};
        margin: 0;
    }
`;
